import React, { useEffect, useState } from 'react';
import { useAppContext } from '../Context';

function Terms() {
    const { termsDropins } = useAppContext();
    const [termsContent, setTermsContent] = useState('');
    
    useEffect(() => {
        fetch('/terms.html')
            .then((response) => response.text())
            .then((data) => {
                const parsedData = data
                    .replace(/\{\{client\}\}/g, termsDropins.client || '<b>UNSET</b>')
                    .replace(/\{\{address\}\}/g, termsDropins.address || '<b>UNSET</b>')
                    .replace(/\{\{legal\}\}/g, termsDropins.legal || '<b>UNSET</b>');
                
                setTermsContent(parsedData);
            })
            .catch((error) => console.error('Error fetching terms:', error));
    }, [termsDropins]);

    return (
        <div className="terms-page-container" style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', textAlign: 'left' }}>
            <div dangerouslySetInnerHTML={{ __html: termsContent }} />
        </div>
    );
}

export default Terms;